import { List } from 'react-movable'
import { Button, LoadingInsertImages, PageShuffleItem } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { selectedPageAtom } from 'atoms'
import { useRecoilValue } from 'recoil'
import { useIsAdmin } from '@/hooks/utility/useIsAdmin'
import * as S from './Menus.styled'
import { usePageShuffler } from 'hooks'

export const PageShufflerMenu = ({ theme, themeOverride, basePages, show }) => {
  const {
    loading,
    disabled,
    preventDelete,
    pages,
    addPage,
    updatePages,
    deletePage,
    goToPage,
    isDeleting,
  } = usePageShuffler(basePages)

  const selectedPage = useRecoilValue(selectedPageAtom)
  const isAdmin = useIsAdmin()

  if (!show) return null

  return loading ? (
    <LoadingInsertImages />
  ) : (
    <Flex column>
      {!disabled && isAdmin && (
        <Flex full center>
          <Button
            margin="0 32px 0 16px"
            width="90%"
            icon="plus"
            onClick={() => addPage()}
          >
            Add Page
          </Button>
        </Flex>
      )}
      <List
        values={pages}
        disabled={false}
        lockVertically
        onChange={({ oldIndex, newIndex }) =>
          updatePages(pages, oldIndex, newIndex)
        }
        renderList={({ children, props, isDragged }) => (
          <S.SortableList isDragged={isDragged} {...props}>
            {children}
          </S.SortableList>
        )}
        renderItem={({ value, props, isDragged, isSelected, index }) => {
          const { key, ...restProps } = props
          return (
            <S.SortableItem
              key={key}
              {...restProps}
              data-testid="page-shuffler-row"
              data-page-number={value?.pageProperties?.pageNumber}
              isSelected={isSelected}
              isDragged={isDragged}
              currentPage={selectedPage === index + 1}
              // react-movable's keyboard lift (Space to lift, arrows to move)
              // has no disabled check, so swallow Space only on the locked
              // guestbook cover row — every other page stays keyboard-
              // reorderable while the cover stays pinned at position 1
              onKeyDownCapture={(e) => {
                if (e.key === ' ' && value.disabled) e.stopPropagation()
              }}
            >
              <PageShuffleItem
                deletePage={deletePage}
                value={value}
                index={index}
                theme={theme}
                themeOverride={themeOverride}
                goToPage={goToPage}
                disabled={disabled}
                preventDelete={preventDelete}
                isDeleting={isDeleting}
              />
            </S.SortableItem>
          )
        }}
      />
    </Flex>
  )
}

export default PageShufflerMenu
